import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { useStore } from "vuex";
import { computed } from "vue";
import { StipulationStatusIds } from "@/config/constants";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import NextButton from "@/components/shared/NextButton.vue";
import CurrentAddressFormModal from "@/components/modals/CurrentAddressFormModal.vue";

interface Props {
  stip: Stipulation;
  applicant: Applicant;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressInput',
  props: {
    stip: {},
    applicant: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const complete = computed(
  () =>
    props.stip.stipulationStatusId === StipulationStatusIds.COMPLETED ||
    props.stip.stipulationStatusId === StipulationStatusIds.CU_OVERRIDE,
);

const modalOpen = computed(() => store.state.modal.currentAddressModalActive);

function openAddressModal() {
  store.state.forms.currentAddressForm.applicantId = props.applicant?.id;
  store.state.forms.currentAddressForm.stipulationId = props.stip?.id;
  store.dispatch("forms/setCurrentAddressForm", store.state.forms.currentAddressForm);
  store.dispatch("modal/openCurrentAddressModal");
}

function closeAddressModal() {
  store.dispatch("modal/closeCurrentAddressModal");
}

return (_ctx: any,_cache: any) => {
  return (!complete.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(NextButton, {
          onClick: openAddressModal,
          text: 'Add an Address'
        }),
        (modalOpen.value)
          ? (_openBlock(), _createBlock(CurrentAddressFormModal, {
              key: 0,
              onClose: closeAddressModal,
              onSuccess: _cache[0] || (_cache[0] = ($event: any) => (emit('success', $event))),
              applicant: __props.applicant,
              stipulation: __props.stip
            }, null, 8, ["applicant", "stipulation"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})